import { Api } from './api';
import { RatingType } from '../redux/ratings/get-ratings.handler';

export class RatingsApi {
    private static readonly PATH = '/ratings';

    constructor(private readonly m_api: Api) {}

    public async getRatings(type: RatingType) {
        return this.m_api.get(`${RatingsApi.PATH}?type=${type}`);
    }
}
